import React from 'react';
import { motion } from 'framer-motion';
import TechVideoBackground from './TechVideoBackground';

interface PageHeroProps {
  label: string;
  labelIcon: React.ReactNode;
  title: React.ReactNode;
  subtitle: string;
  children?: React.ReactNode;
}

const PageHero: React.FC<PageHeroProps> = ({ label, labelIcon, title, subtitle, children }) => {
  return (
    <section style={{
      paddingTop: 160,
      paddingBottom: 80,
      position: 'relative',
      overflow: 'hidden',
      background: 'var(--bg-secondary)',
    }}>
      <TechVideoBackground variant="hero" opacity={0.5} />
      <div className="circuit-pattern" />

      {/* Gradient orbs */}
      <div className="hero-orb hero-orb-1" />
      <div className="hero-orb hero-orb-2" />

      <div className="container" style={{ position: 'relative', zIndex: 2, textAlign: 'center' }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="section-label">
            {labelIcon}
            {label}
          </span>
        </motion.div>
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          style={{
            fontSize: 'clamp(2.2rem, 5vw, 3.8rem)',
            fontWeight: 900,
            lineHeight: 1.1,
            marginBottom: 20,
            letterSpacing: '-0.02em',
          }}
        >
          {title}
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          style={{
            fontSize: 'clamp(1rem, 1.8vw, 1.2rem)',
            color: 'var(--text-secondary)',
            maxWidth: 640,
            margin: '0 auto',
            lineHeight: 1.7,
          }}
        >
          {subtitle}
        </motion.p>
        {children && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.3 }}
            style={{ marginTop: 32 }}
          >
            {children}
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default PageHero;
